export default __webpack_public_path__ + "static/hialgocase1-c8f6461cde6b78ba6771699db40e593e.png";